
export enum SerializationMode {
  JSON = 1,
  XML = 2
}
